const ReturnToFormate = (inputDate) => {
  if (!inputDate) return null; // Handle null or undefined input

  // Check if the input is a Date object
  if (inputDate instanceof Date) {
    const year = inputDate.getFullYear();
    const month = String(inputDate.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const day = String(inputDate.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`; // Return formatted date as 'YYYY-MM-DD'
  }

  // Split the input date by '-' (assuming input is in 'YYYY-MM-DD' format)
  const [year, month, day] = inputDate.split("-");

  // Check if the year, month, and day are valid
  if (!year || !month || !day) return null; // Return null if any part of the date is missing

  // Construct the date in the 'YYYY-MM-DD' format (this is already correct for Date constructor)
  const formattedDate = `${year}-${month}-${day}`;

  // Create the Date object using the formatted date string
  const date = new Date(formattedDate);

  // Check if the date is valid
  if (isNaN(date.getTime())) {
    // console.error("Invalid date format");
    return null; // Return null for invalid dates
  }

  return date;
};

export default ReturnToFormate;
